export default __webpack_public_path__ + "static/media/cross-curriculum.f873b1d8.svg";